import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IDeleteEntity, IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';

@Injectable({
    providedIn: 'root'
})
export class TaskTimerService {
    constructor(private http: HttpClient, private log: LoggingService) {}

    private uri = `${environment.apiLocation}/TaskTimer`;
    private histUri = `${environment.apiLocation}/TaskTimerHistory`;

    public post(startDate: string, endDate: string): Observable<any> {
        this.log.verbose({
            type: 'TaskTimerService:get',
            uri: this.uri
        });
        return this.http
            .post<any>(this.histUri, { StartDate: startDate, EndDate: endDate })
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'TaskTimerService:response',
                        res
                    })
                )
            );
    }

    public get(): Observable<any> {
        this.log.verbose({
            type: 'TaskTimerService:get',
            uri: this.uri
        });
        return this.http.get<any>(this.uri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'TaskTimerService:response',
                    res
                })
            )
        );
    }

    public put(
        jsonstring: string,
        StartDate?: string,
        EndDate?: string
    ): Observable<any> {
        return this.http
            .put<any>(this.uri, {
                JsonString: jsonstring
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'TaskTimerService:put',
                        data
                    })
                )
            );
    }
}
